<div class="wrapper">
  <div class="header drop-padding">
    <h2 class="mat-title">Выбор товара</h2>
    <mat-form-field>
      <mat-label>Поиск</mat-label>
      <input matInput type="text" [formControl]="searchControlValue" />
    </mat-form-field>
  </div>
  <div class="body">
    <app-product-table [loading]="loading" [products]="products"></app-product-table>
  </div>
</div>
